import { Fragment, useState, type FormEvent } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Mail } from 'react-feather';
import { appToast, toastApiError } from '@/core/error/toast';
import { forgotPassword } from '@/features/auth/api';
import logo from '@/assets/images/logo/logo.png';
import authIllustration from '@/assets/images/login/auth-img.svg';

const FEATURES = [
  'Secure one-time reset link from your administrator',
  'Choose a strong password of at least 8 characters',
  'Sign in immediately after updating your password',
];

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const res = await forgotPassword(email.trim());
      setSent(true);
      appToast.info(
        res.emailed
          ? res.message
          : `${res.message} (Email delivery not enabled in this environment.)`,
      );
    } catch (err) {
      toastApiError(err, 'Could not submit reset request.');
    }
  };

  return (
    <Fragment>
      <div className="credora-login">
        <div className="credora-login__shell">
          <aside className="credora-login__brand" aria-hidden="true">
            <div className="credora-login__brand-inner">
              <p className="credora-login__eyebrow">Account security</p>
              <h1 className="credora-login__headline">
                Reset access
                <span> securely</span>
              </h1>
              <p className="credora-login__tagline">
                Enter your email and we will send a one-time reset link when available.
              </p>
              <ul className="credora-login__features">
                {FEATURES.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="credora-login__illustration">
                <img src={authIllustration} alt="" />
              </div>
            </div>
          </aside>

          <main className="credora-login__panel">
            <div className="credora-login__card">
              <Link className="credora-login__logo credora-brand-logo" to="/login">
                <img src={logo} alt="RCATS" className="img-fluid credora-brand-logo__img" />
              </Link>
              <div className="credora-login__form-header">
                <h4>Forgot password</h4>
                <p>Enter your account email to receive a reset link.</p>
              </div>
              {sent ? (
                <p className="text-muted">
                  If an account exists for <strong>{email}</strong>, instructions will be sent.
                </p>
              ) : (
                <Form className="theme-form credora-login__form" onSubmit={onSubmit}>
                  <FormGroup>
                    <Label className="col-form-label" for="forgot-email">
                      Email Address
                    </Label>
                    <div className="credora-login__input-wrap">
                      <Mail className="credora-login__input-icon" size={18} aria-hidden="true" />
                      <Input
                        id="forgot-email"
                        type="email"
                        required
                        className="form-control credora-login__input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </FormGroup>
                  <button type="submit" className="btn btn-primary w-100 credora-login__submit">
                    Send reset link
                  </button>
                </Form>
              )}
              <p className="text-center mt-3 mb-0">
                <Link to="/login">Back to sign in</Link>
              </p>
              <p className="credora-login__footer-note">
                Authorized staff and parents only.
              </p>
            </div>
          </main>
        </div>
      </div>
    </Fragment>
  );
}
